<template>
    <div class="about-gptw-root">
        <Header overlap="large" />

        <MainLayout marginTop>
            <Paper
                slot="center"
                header="What is Great Place To Work?"
                padding
                noHeaderPadding
            >
                <BaseButton
                    v-if="getHistoryLength() > 1"
                    slot="header"
                    variant="outline-dark"
                    tiny
                    class="m-2"
                    @click="handleGoBackClick"
                >
                    Go back
                </BaseButton>

                <p>
                    Labore voluptate consequat aliquip reprehenderit esse.
                    Pariatur ex proident consectetur cupidatat fugiat cupidatat.
                    Consectetur magna ut non incididunt officia aliquip ad
                    voluptate eiusmod ad nulla ullamco. Consectetur eiusmod
                    laboris incididunt do consequat nisi eu duis ad minim.
                    Incididunt nostrud consectetur non eiusmod ullamco anim
                    laboris quis duis qui sit nisi labore in. Commodo tempor
                    esse labore sit commodo esse. Nulla nostrud excepteur
                    voluptate incididunt adipisicing pariatur.
                </p>

                <h4>Hear from GPTW's CEO</h4>

                <div style="overflow: hidden; max-width: 400px">
                    <VideoCarouselItem
                        @click="() => handleVideoClick('rjyfhlabm8')"
                        style="max-width: 400px"
                        img="https://higheredimagestoragedev.blob.core.windows.net/companyimages/2324e262-0dbc-48d5-9b87-b479b350b4ea"
                        videoLink="rjyfhlabm8"
                    />
                </div>
            </Paper>

            <Paper
                slot="center"
                header="Certified Great Places To Work"
                tall
                padding
            >
                hello world
                <BaseCheckbox v-model="consented" />
                <h2>{{ consented }}</h2>
            </Paper>

            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
        </MainLayout>
    </div>
</template>

<script>
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';

import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import FeaturedResource from '~/components/smart/FeaturedResource';

import VideoCarouselItem from '~/components/miscellaneous/Videos.CarouselItem';

import DialogService from '~/services/DialogService';

export default {
    name: 'AboutGPTW',
    components: {
        Header,
        MainLayout,
        ProfileModule,
        FeaturedResource,
        VideoCarouselItem,
    },
    data: () => ({
        consented: false,
    }),
    methods: {
        getHistoryLength() {
            return window.history.length;
        },
        handleGoBackClick() {
            // console.log(window.history)
            window.history.back();
        },
        handleVideoClick(videoLink) {
            DialogService.openVideoDialog({ id: '123123123123123', videoLink });
        },
        onChanged(event) {
            //console.log(event);
            this.consented = event.target.checked;
        },
    },
};
</script>

<style scoped></style>
